import { Outlet } from "react-router-dom";
import AdminLayoutShell from "../../admin/navigation/AdminLayoutShell";
import {
  customerSidebarSections,
  CUSTOMER_PANEL_HOME,
  getCustomerPageTitle,
} from "./customerNavigation";
import "../../admin/navigation/AdminShell.css";

const CustomerDashboardLayout = ({ children }) => {
  return (
    <AdminLayoutShell
      sections={customerSidebarSections}
      homePath={CUSTOMER_PANEL_HOME}
      logoutRedirect="/login"
      titleGetter={getCustomerPageTitle}
    >
      {children ?? <Outlet />}
    </AdminLayoutShell>
  );
};

export default CustomerDashboardLayout;
